"use client";
import { ChevronLeft, ChevronRight, ChevronsLeft } from "@layer/icons";
import { cn } from "@layer/utils/cn";
import type { Table } from "@tanstack/react-table";
import {
	Button,
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "../../../components";

type DataTablePaginationProps<TData> = {
	table: Table<TData>;
	hideRowsSelected?: boolean;
	hasNextPage?: boolean;
	paginationColor?: string;
	isRunbook?: boolean;
};

const Pagination = <TData,>({
	table,
	hideRowsSelected,
	hasNextPage,
	paginationColor,
	isRunbook,
}: DataTablePaginationProps<TData>) => {
	return (
		<div
			className={cn(
				`h-12 table-pagination flex items-center justify-between border-t border-app-border-strong py-2 px-4 ${paginationColor ?? "bg-app-bg-surface-strong/95"}`,
				isRunbook && "border-app-border",
			)}
		>
			{hideRowsSelected ? (
				<div className="flex-1" />
			) : (
				<div className="text-accent-text flex-1 font-mono text-sm">
					{table.getFilteredSelectedRowModel().rows.length}/
					{table.getFilteredRowModel().rows.length}
				</div>
			)}
			<div className="flex items-center gap-x-4">
				<div className="flex items-center space-x-2">
					<Select
						value={`${table.getState().pagination.pageSize}`}
						onValueChange={(value) => {
							table.setPageSize(Number(value));
						}}
					>
						<SelectContent side="top">
							{[25, 50, 100].map((pageSize) => (
								<SelectItem
									key={pageSize}
									value={`${pageSize}`}
								>
									{pageSize}
								</SelectItem>
							))}
						</SelectContent>
						<SelectTrigger className="px-2 h-6!">
							<SelectValue
								placeholder={
									table.getState().pagination.pageSize
								}
							/>
						</SelectTrigger>
					</Select>
				</div>
				<div className="flex items-center space-x-2">
					<Button
						size="icon"
						variant="outline"
						className="h-6 w-6"
						onClick={() => table.setPageIndex(0)}
						disabled={!table.getCanPreviousPage()}
					>
						<ChevronsLeft />
					</Button>
					<Button
						size="icon"
						variant="outline"
						className="h-6 w-6"
						onClick={() => table.previousPage()}
						disabled={!table.getCanPreviousPage()}
					>
						<ChevronLeft />
					</Button>
					<Button
						size="icon"
						variant="outline"
						className="h-6 w-6"
						onClick={() => table.nextPage()}
						disabled={!hasNextPage}
					>
						<ChevronRight />
					</Button>
				</div>
				{/* TODO STLF: REINSTATE WHEN PAGINATED API RETURNS TOTALCOUNT RESPONSE  */}
				{/* <div className="flex items-center justify-center text-sm font-mono">
					{table.getState().pagination.pageIndex + 1}/
					{table.getPageCount()}
				</div> */}
			</div>
		</div>
	);
};

export { Pagination };
